import React from "react";
import { dateFormator } from "../../../../../../utils";

const TimesheetFooter = ({
  data = {},
  color = "primary",
  colorDepth = 500,
  type = "main", // main, sub
  currentPage,
  totalPages,
}) => {
  return type === "main" ? (
    <div className={`px-5 text-xs flex justify-center`}>
      <div
        className={`px-5 py-2 pt-2.5 bg-${color}-${colorDepth} text-white rounded-t-xl w-full max-w-[900px]`}
      >
        {/* TimesheetFooter main {currentPage} of {totalPages} */}
        <div className={`text-${color}-50`}>Powerd by KultWorks</div>
      </div>
    </div>
  ) : (
    <div className="px-5 border-t border-slate-100">
      <div className="pb-3 pt-3 w-full grid grid-cols-[1fr_auto_1fr] items-center text-neutral-400 text-xs">
        <div className="flex flex-col gap-0.5">
          <p>{data?.company?.name}</p>
          <p>{data?.company?.address},</p>
          <p>
            {data?.company?.contact} | {data?.company?.website}
          </p>
        </div>
        <div>
          {currentPage} of {totalPages}
        </div>
        <div className="text-right">
          {dateFormator(new Date().toLocaleDateString(), "short")}
        </div>
      </div>
    </div>
  );
};

export default TimesheetFooter;
